import * as React from "react"
import {useEffect} from "react"
import {Grid} from "@mui/material";

import {BANNERS_ROUTES} from "@constants"
import PageWrapper from "Pages/@PageWrapper"
import {isSystemBusy,} from "@signals";
import {resetBannersPercentageSignals, isBannersPercentageEmpty} from "./@signals";
import BannersPercentageFilters from "./Filters";
import BannersPercentageHighLevel from "./HighLevel";
import BannersPercentageDynamic from "./Dynamic";
import BannersPercentageReach from "./Reach";

export default function BannersPercentagePage() {

    useEffect(() => {
        return () => resetBannersPercentageSignals()
    }, []);

    return <PageWrapper
        head={`DIP Insight | ${BANNERS_ROUTES.PERCENTAGE_TITLE}`}
        title={BANNERS_ROUTES.PERCENTAGE_TITLE}
        subtitle={BANNERS_ROUTES.PERCENTAGE_SUBTITLE}
        filters={<BannersPercentageFilters />}
        hasErrors={isSystemBusy.value}
        isEmpty={isBannersPercentageEmpty.value}
    >
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <BannersPercentageHighLevel />
            </Grid>

            <Grid item xs={12}>
                <BannersPercentageDynamic />
            </Grid>

            <Grid item xs={12}>
                <BannersPercentageReach />
            </Grid>
        </Grid>
    </PageWrapper>
}